module.exports = __webpack_public_path__ + "static/media/q_type_3.c1f59984.png";